<script setup>
import { ref, onMounted } from 'vue';
import { useAlert } from 'dashboard/composables';
import AutomationConfigAPI from 'dashboard/api/automationConfig';
import RuntimeSettings from './mres3/RuntimeSettings.vue';

const config = ref({ sending_enabled: false, simulated_count: 0, sent_count: 0 });
const loading = ref(false);

const load = async () => {
  loading.value = true;
  try {
    const { data } = await AutomationConfigAPI.get();
    config.value = data;
  } catch (e) {
    useAlert('Не удалось загрузить настройки');
  } finally {
    loading.value = false;
  }
};
onMounted(load);

const toggle = async () => {
  const next = !config.value.sending_enabled;
  if (
    next &&
    !window.confirm(
      'Включить реальную отправку? До этого момента всё работало в режиме dry-run. ' +
        'Убедись, что MRES-уведомления не задублируются.'
    )
  ) {
    return;
  }
  try {
    const { data } = await AutomationConfigAPI.save(next);
    config.value = data;
  } catch (e) {
    useAlert('Не удалось изменить настройку');
  }
};
</script>

<template>
  <div class="flex flex-col w-full h-full overflow-auto bg-n-surface-1">
    <div class="w-full max-w-2xl px-6 py-6">
      <h1 class="mb-1 text-xl font-medium text-n-slate-12">Настройки автоматизации</h1>
      <p class="mb-6 text-sm text-n-slate-11">
        Главный рубильник системы уведомлений MedUp Chat. Запуск фидера сделок —
        на странице коннектора MedUp (Настройки → Интеграции → MedUp).
      </p>

      <div class="p-4 mb-4 border rounded-xl border-n-weak bg-n-solid-1">
        <div class="flex items-center justify-between">
          <div>
            <div class="font-medium text-n-slate-12">Реальная отправка</div>
            <div class="text-sm text-n-slate-11">
              Выключено — действия сценариев только пишутся в журнал (dry-run). MRES шлёт как раньше.
            </div>
          </div>
          <button
            type="button"
            class="px-4 py-2 text-sm rounded-lg"
            :class="
              config.sending_enabled
                ? 'bg-n-teal-9 text-white'
                : 'bg-n-alpha-2 text-n-slate-11'
            "
            @click="toggle"
          >
            {{ config.sending_enabled ? 'Включена' : 'Выключена' }}
          </button>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <div class="p-4 border rounded-xl border-n-weak bg-n-solid-1">
          <div class="text-2xl font-semibold tabular-nums text-n-slate-12">
            {{ config.simulated_count }}
          </div>
          <div class="text-sm text-n-slate-11">dry-run (simulated)</div>
        </div>
        <div class="p-4 border rounded-xl border-n-weak bg-n-solid-1">
          <div class="text-2xl font-semibold tabular-nums text-n-slate-12">
            {{ config.sent_count }}
          </div>
          <div class="text-sm text-n-slate-11">реально отправлено</div>
        </div>
      </div>
      <RuntimeSettings />
    </div>
  </div>
</template>
